import React from 'react';


export default function Footer() {
    return (
        <div className="footer-cont">
            <footer className='footer-box'>
                <a href="https://www.linkedin.com/in/bosalinas/" className="fa fa-linkedin"></a>
                <a href="https://github.com/bosalinas" className="fa fa-github"></a>
                <a href="https://www.instagram.com/itsaboisworld/" className="fa fa-instagram"></a>
            </footer>
        </div>
    )
}

